export default __webpack_public_path__ + "locales/lo-LA/DataReassignmentDialog.json?hash=782af30604f448f68792660d88585b10";